import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid typeahead-page" }
const _hoisted_2 = { class: "typeahead" }
const _hoisted_3 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'IndexTypeahead',
  setup(__props) {

const BasicTypeahead = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/typeahead/BasicTypeahead.vue"))
const PrefetchTypeahead = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/typeahead/PrefetchTypeahead.vue"))
const BloodhoundTyeahead = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/typeahead/BloodhoundTyeahead.vue"))
const RemoteTypeahead = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/typeahead/RemoteTypeahead.vue"))
const CustomTemplates = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/typeahead/CustomTemplates.vue"))
const MultipleSections = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/typeahead/MultipleSections.vue"))
const ScrollableMenu = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/typeahead/ScrollableMenu.vue"))
const RtlSupport = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/typeahead/RtlSupport.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Form Controls",
      mains: "Typeahead",
      title: "Typeahead"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(BasicTypeahead)),
          _createVNode(_unref(PrefetchTypeahead)),
          _createVNode(_unref(BloodhoundTyeahead)),
          _createVNode(_unref(RemoteTypeahead)),
          _createVNode(_unref(CustomTemplates)),
          _createVNode(_unref(MultipleSections)),
          _createVNode(_unref(ScrollableMenu)),
          _createVNode(_unref(RtlSupport))
        ])
      ])
    ])
  ], 64))
}
}

})